var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoadingIndicatorcom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 30",
  height: "1em",
  width: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  opacity: 0.2,
  d: "M0 10h4v10H0z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  values: "0.2; 1; .2",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "10; 20; 10",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "10; 5; 10",
  begin: "0s",
  dur: "0.6s",
  repeatCount: "indefinite"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  opacity: 0.2,
  d: "M8 10h4v10H8z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  values: "0.2; 1; .2",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "10; 20; 10",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "10; 5; 10",
  begin: "0.15s",
  dur: "0.6s",
  repeatCount: "indefinite"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  opacity: 0.2,
  d: "M16 10h4v10h-4z"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  attributeType: "XML",
  values: "0.2; 1; .2",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "height",
  attributeType: "XML",
  values: "10; 20; 10",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "y",
  attributeType: "XML",
  values: "10; 5; 10",
  begin: "0.3s",
  dur: "0.6s",
  repeatCount: "indefinite"
}))));
export default SvgLoadingIndicatorcom;